import React, { ReactNode } from 'react';
import { AuthProvider } from '../../context/Auth/AuthContext';
import { PointsProvider } from '../../context/PointsContext';
import { NotificationProvider } from '../../context/NotificationContext';
import { TitleGenerationProvider } from '../../context/TitleGenerationContext';
import { ThumbnailProvider } from '../../context/ThumbnailContext';
import { CaptionModalProvider } from '../../context/CaptionModalContext';
import { LimitExceededProvider } from '../../context/LimitExceededContext';
import { SessionTimeoutContainer } from '../SessionTimeout';
import LimitExceededModal from '../Modal/LimitExceededModal';

interface ContextProvidersProps {
  children: ReactNode;
}

// This component wraps all the context providers that our app needs
// It should be used inside routes when the router is already available
const ContextProviders: React.FC<ContextProvidersProps> = ({ children }) => {
  return (
    <AuthProvider>
      <SessionTimeoutContainer>
        <PointsProvider>
          <NotificationProvider>
            <LimitExceededProvider>
              <TitleGenerationProvider>
                <ThumbnailProvider>
                  <CaptionModalProvider>
                    {children}
                    {/* Render limit exceeded modal at root level */}
                    <LimitExceededModal />
                  </CaptionModalProvider>
                </ThumbnailProvider>
              </TitleGenerationProvider>
            </LimitExceededProvider>
          </NotificationProvider>
        </PointsProvider>
      </SessionTimeoutContainer>
    </AuthProvider>
  );
};

export default ContextProviders;